export default __webpack_public_path__ + "static/media/avatar_dragon5.6e725867.mp3";